import { useState } from 'react';
import clarityIcon from '../assets/clarity-support-icon.png';
import ChangeRequestModal from './ChangeRequestModal';

export default function SupportFab() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="fixed bottom-6 right-6 z-40 h-14 w-14 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-NBNA-primary focus:ring-offset-2 bg-white"
        aria-label="Submit feedback"
        title="Submit feedback"
      >
        <img
          src={clarityIcon}
          alt=""
          className="h-full w-full rounded-full object-cover"
        />
      </button>
      <ChangeRequestModal isOpen={open} onClose={() => setOpen(false)} />
    </>
  );
}
